!(async () => {
  const LOADING_CLASS = 'btn--loading'
  const addToCartCallback = () => {
      document.dispatchEvent(new CustomEvent('cart:build'))
      document.dispatchEvent(new CustomEvent('cart:open'))
  }
  const registerHandler = (selector, callback) => {
    document.body.addEventListener('click', (evt) => {
      const elm = evt.path.find(e => e && e.matches && e.matches(selector))
      if(elm) {
        callback(elm)
      }
    })
  }

  const addToCart = async (variantId, qty = 1, options = {}) => {
      return await (await fetch('/cart/add.js', {
        method: 'POST',  
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [
                {
                    ...options,
                    id: variantId,
                    quantity: qty
                }
            ]
        })
      })).json()
  }

  window.addToCart = addToCart

  registerHandler('[data-cart-add]', async elm => {
    console
    elm.classList.add(LOADING_CLASS)
    let qty = parseInt(elm.dataset.cartQuantity || '1')
    if (elm.dataset.cartQuantitySelector) {
      const qtyElm = document.querySelector(elm.dataset.cartQuantitySelector)
      if(qtyElm) {
        qty = parseInt(qtyElm.value || qty)
      }
    }
    const variantId = elm.dataset.cartAdd
    const options = {}
    if (elm.dataset.cartSellingPlan) {
      options.selling_plan = elm.dataset.cartSellingPlan
    }
    await addToCart(variantId, qty, options)
    addToCartCallback()
    elm.classList.remove(LOADING_CLASS)
  })

})()